import { css, StyleSheet } from 'aphrodite'
import * as React from 'react'

import { IUnitType } from '../../engine/unit'
import races from '../../engine/units/races'
import Dialog from '../components/Dialog'
import Layout from '../components/layout'
import UnitGlyph from '../components/unitGlyph'
import MainStore from '../mainStore'
import style from '../utils/style'

const CHEAT_CODE = 'hexacheat'

const styles = StyleSheet.create({
  main: {
    textAlign: 'center',
    background: style.darkGrey,
    color: style.textColor,
    position: 'absolute',
    left: 0, top: 0, right: 0, bottom: 0,
    border: style.border,
  },
  button: {
    cursor: 'pointer',
    ':hover': {
      color: 'white',
      stroke: 'white',
    },
  },
  blockedLevel: {
    opacity: .6,
  },
  description: {
    minHeight: 24,
    paddingTop: 6,
  },
  shopContent: {
    overflow: 'hidden',
  },
  sectionTitle: {
    margin: '6px 0',
  },
  unitGrid: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  unitButton: {
    width: 82,
  },
  unitIcon: {
    width: 38,
    height: 38,
    padding: 4,
  },
  selectedUnits: {
    maxHeight: 76,
    overflow: 'hidden',
  },
  selectedIcon: {
    width: 28,
    height: 28,
    padding: 2,
  },
})

interface IProps {
  store: MainStore,
  onCancel: () => void
}

interface IState {
  cart: IUnitType[]
  hoveredUnit?: IUnitType,
}

export default class ShopDialog extends React.Component<IProps, IState> {
  cheatBuffer = ''
  cheatListening = false

  state: IState = {
    cart: [],
  }

  componentWillUnmount() {
    this.stopCheatTracking()
  }

  get totalCost() {
    return this.state.cart.reduce((prev, u) => prev + u.cost, 0)
  }

  get remainingMoney() {
    const { money } = this.props.store.state
    return money - this.totalCost
  }

  onSelectUnit = (unit: IUnitType) => {
    if (this.remainingMoney >= unit.cost) {
      this.setState({ cart: [...this.state.cart, unit]})
    }
  }

  startCheatTracking = () => {
    this.cheatBuffer = ''

    if (!this.cheatListening) {
      document.addEventListener('keypress', this.onCheatKeyPress)
      this.cheatListening = true
    }
  }

  stopCheatTracking() {
    if (this.cheatListening) {
      document.removeEventListener('keypress', this.onCheatKeyPress)
    }
    this.cheatListening = false
    this.cheatBuffer = ''
  }

  onCheatKeyPress = (e: KeyboardEvent) => {
    const key = e.key || String.fromCharCode(e.charCode)
    if (!key || key.length !== 1) {
      return
    }

    this.cheatBuffer = (this.cheatBuffer + key.toLowerCase())
      .slice(-CHEAT_CODE.length)

    if (this.cheatBuffer === CHEAT_CODE) {
      this.props.store.unlockAdmin()
      this.cheatBuffer = ''
    }
  }

  renderUnitButton = (unit: IUnitType, idx: number) => {
    return (
      <div
        className={css(styles.button)}
        key={idx}
        onClick={() => this.onSelectUnit(unit)}
        onMouseOver={() => this.setState({ hoveredUnit: unit })}
      >
        <Layout classes={[styles.unitButton]}>
          <UnitGlyph
            unitType={unit}
            wrapped={true}
            classes={styles.unitIcon}
          />
          {unit.cost}💰
        </Layout>
      </div>
    )
  }

  onPurchase = () => {
    this.props.store.purchase(this.state.cart, this.totalCost)
    this.props.onCancel()
  }

  render() {
    const { hoveredUnit } = this.state
    const { onCancel } = this.props

    return (
      <Dialog>
        <Dialog.Title onClick={this.startCheatTracking}>SHOP</Dialog.Title>
        <Dialog.Content classes={[styles.shopContent]}>
          <h3 className={css(styles.sectionTitle)}>Select</h3>
          <div>
            <Layout
              direction="row"
              wrap="wrap"
              classes={[styles.unitGrid]}
            >
              {races.humans.map(this.renderUnitButton)}  
            </Layout>
          </div>  
          <div className={css(styles.description)}>
            {hoveredUnit && hoveredUnit.description}
          </div>
          <h3 className={css(styles.sectionTitle)}>Selected</h3>
          <Layout
            direction="row"
            wrap="wrap"
            justify="center"
            classes={[styles.selectedUnits]}
          >
            {this.state.cart.map((u, idx) => (
              <span key={idx}>
                <UnitGlyph
                  unitType={u}
                  wrapped={true}
                  classes={styles.selectedIcon}
                />
              </span>
            ))}
          </Layout>
          <div>
            💰 {this.remainingMoney} Remaining
          </div>
        </Dialog.Content>
        <Dialog.Controls>
          <Dialog.Control onClick={this.onPurchase}>
            Confirm Purchase
          </Dialog.Control>
          <Dialog.Control onClick={onCancel}>
            Cancel
          </Dialog.Control>
        </Dialog.Controls>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/mainView/shopDialog.tsx